import { render, staticRenderFns } from "./tab-nav-items.vue?vue&type=template&id=4d19d85c"
import script from "./tab-nav-items.vue?vue&type=script&lang=js"
export * from "./tab-nav-items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports